export default "__VITE_ASSET__DK4MQsK1__"